<template>
  <ion-page>
    <!-- 
      <ion-header :translucent="true">
        <ion-toolbar>
          <ion-title>Login5</ion-title>
        </ion-toolbar>
      </ion-header> -->

    <ion-content :fullscreen="true">
      <div class="w-screen h-screen flex items-center justify-center">
        <loading-state v-if="!isLocal" />
        <!-- <template v-if="isAuthenticated">
          <p class="hidden">{{ getToken() }}</p>
        </template> -->
        <LocalLogin v-if="isLocal" :usernames="usernames" />
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonButton,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/vue";
import axios from "axios";
import { Browser } from "@capacitor/browser";
import { defineComponent } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { mapActions } from "vuex";
import {
  createRedirectUri,
  getLoginPathObj,
  clearLoginPathObj,
} from "../../utils/redirect-uri";
import { useRoute } from "vue-router";
import { computed, ref, watch } from "vue";
import LoadingState from "@/components/common/LoadingState.vue";
import LocalLogin from "@/components/Local/localLogin.vue";
import { log } from "video.js";

export default defineComponent({
  name: "HomePage",
  components: {
    IonButton,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    LoadingState,
    LocalLogin,
  },

  setup() {
    const { loginWithRedirect, isAuthenticated, user, checkSession } =
      useAuth0();
    const logoutUri = createRedirectUri(
      process.env.VUE_APP_PACKAGE_ID,
      process.env.VUE_APP_AUTH0_DOMAIN
    );
    const isBrowserOpen = ref(false);
    const isLocal = computed(() => process.env.VUE_APP_NODE_ENV === "local");
    const usernames = ref(() => []);
    const route = useRoute();
    let finalUrl = "";

    const login = async () => {
      const deepLinkPathObj = JSON.parse(
        sessionStorage.getItem("deepLinkPathObj")
      );
      const config = {
        appState: {
          target: "/home",
          fullPathObj: deepLinkPathObj,
        },
      };
      if (route.query.login_hint) {
        config.authorizationParams = {
          login_hint: route.query.login_hint,
        };
      }
      console.log("before redirecting");
      await loginWithRedirect(config);
      isBrowserOpen.value = true;
      console.log("done redirecting");
    };

    function delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    return {
      isAuthenticated,
      user,
      login,
      isBrowserOpen,
      delay,
      checkSession,
      isLocal,
      usernames,
    };
  },
  data() {
    return {
      token: "",
    };
  },
  async mounted() {
    console.log("login mounted is authenticated:", this.isAuthenticated);
    if (!this.isAuthenticated) {
      if (!this.isLocal) {
        await this.login();
      } else {
        const { data: usernames } = await axios.get(
          process.env.VUE_APP_API_URL + "/local/usernames"
        );
        this.usernames = usernames;
      }
    } else {
      this.$router.push("/home");
    }
  },
  async created() {
    Browser.addListener("browserFinished", async () => {
      this.isBrowserOpen = false;
    });
  },
  methods: {
    ...mapActions("user", ["setToken"]),
    async getToken() {
      const route = useRoute();
      const path = computed(() => route.path);
      const fromPath = computed(() => route.redirectedFrom);
      if (process.env.VUE_APP_NODE_ENV === "local") {
        this.token = localStorage.getItem("token");
      } else {
        const { getAccessTokenSilently } = useAuth0();
        this.token = await getAccessTokenSilently();
      }
      if (path.value.includes("login")) {
        const loginPathObj = getLoginPathObj();
        if (loginPathObj && loginPathObj.path !== "/") {
          console.log("forwarding login path:", JSON.stringify(loginPathObj));
          this.$router.push({
            path: loginPathObj.path,
            query: loginPathObj.query,
            hash: loginPathObj.hash,
          });
        } else {
          this.$router.push("/home");
        }
      }
      if (path.value.includes("pre-sign-in")) {
        this.$router.push("/home");
      }
      this.setToken(this.token);
    },
  },
});
</script>

<style scoped>
#container {
  text-align: center;

  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;

  color: #8c8c8c;

  margin: 0;
}

#container a {
  text-decoration: none;
}
</style>
